export const GET_JOB_STORY = 'GET_JOB_STORY';
export const LOADING_JOB_STORY = 'LOADING_JOB_STORY';
export const SAVE_LOADER_JOB_STORY = 'SAVE_JOB_STORY';
